// Bilingual content for Adtree Go landing page
export const translations = {
  id: {
    nav: {
      about: "Tentang",
      services: "Layanan",
      creators: "Creator",
      testimonial: "Testimoni",
      join: "Gabung",
    },
    cta: {
      join: "Gabung Sekarang",
      joinNetwork: "Gabung Jaringan Eksklusif",
      explore: "Pelajari",
      submit: "Kirim Pendaftaran",
      submitWa: "Daftar via WhatsApp",
      sending: "Mengirim...",
    },
    hero: {
      eyebrow: "Premium MCN · 2026",
      title1: "Mengubah Perhatian",
      title2: "Menjadi Transaksi.",
      desc: "Mesin creator‑commerce kami mengubah pengaruh menjadi pertumbuhan brand dari momen kuliner viral hingga GMV miliaran rupiah untuk partner kita.",
      stat1: "Kreator Adtree",
      stat2: "Brand Partner",
      stat3: "GMV",
      stat4: "Jangkauan Bulanan",
    },
    about: {
      eyebrow: "Siapa Kita",
      title: "Kami menghubungkan rasa, ruang, dan cerita.",
      p1: "Adtree Go adalah multi‑channel network (MCN) generasi baru — fokus tajam pada dua dunia yang paling cepat tumbuh di Indonesia: kuliner dan akomodasi. Kami bantu creator monetisasi konten, sambil bantu brand membangun cerita yang otentik.",
      p2: "Dari food reviewer berdampak hingga staycation storyteller, kami mengkurasi creator terbaik untuk berkolaborasi dengan restoran, kafe, hotel, dan villa premium — semua dalam satu ekosistem.",
      pillarsTitle: "Pilar Kami",
      pillar1Title: "Kurasi Premium",
      pillar1Desc: "Setiap creator melewati kurasi ketat untuk menjaga kualitas brand.",
      pillar2Title: "Komersialisasi",
      pillar2Desc: "Rate card transparan, brand deal eksklusif, dan voucher loyalitas.",
      pillar3Title: "Cerita Otentik",
      pillar3Desc: "Konten sinematik yang membangun brand jangka panjang, bukan sekadar postingan.",
    },
    services: {
      eyebrow: "Layanan Kami",
      title: "Dua dunia, satu jaringan.",
      diningTag: "Adtree Go Dining",
      diningTitle: "Untuk Creator Dining",
      diningDesc: "Restoran, kafe, gourmet, street food — kami menghubungkanmu dengan brand kuliner premium dan campaign nasional.",
      diningPoints: ["Brand deal restoran & FMCG", "Food voucher eksklusif", "Photo & video production", "Distribusi multi‑platform"],
      stayTag: "Adtree Go Stay / Luxe",
      stayTitle: "Untuk Creator Akomodasi",
      stayDesc: "Hotel, resort, villa, glamping — bercerita tentang pengalaman menginap mewah bersama hotel terbaik di Indonesia.",
      stayPoints: ["Staycation eksklusif", "Hotel voucher premium", "Hospitality storytelling", "Kolaborasi destinasi"],
    },
    benefits: {
      eyebrow: "Kenapa Adtree Go",
      title: "Lebih dari sekadar manajemen creator.",
      list: [
        { t: "Monetisasi Konsisten", d: "Brand deal bulanan dengan rate yang fair dan transparan." },
        { t: "Voucher Eksklusif", d: "Akses voucher hotel & dining untuk creator terpilih." },
        { t: "Eksposur Massive", d: "Konten kamu didistribusikan ke jaringan 10M+ audiens." },
        { t: "Tim Kreatif", d: "Photographer, videographer, dan editor in‑house siap support." },
        { t: "Legal & Kontrak", d: "Kami urus kontrak, invoice, dan pajak — kamu fokus berkarya." },
        { t: "Komunitas", d: "Bergabung dengan komunitas creator Dining & akomodasi terbaik." },
      ],
    },
    partners: {
      eyebrow: "Trusted by Brands",
    },
    testimonials: {
      eyebrow: "Testimoni",
      title: "Apa kata creator kami.",
    },
    register: {
      eyebrow: "Pendaftaran Creator",
      title: "Saatnya naik level. Daftar jadi creator Adtree Go.",
      desc: "Lengkapi formulir di bawah. Tim kami akan menghubungi kamu dalam 3–5 hari kerja.",
      labels: {
        full_name: "Nama Lengkap",
        email: "Email",
        whatsapp: "WhatsApp",
        category: "Kategori",
        social_handle: "Instagram / TikTok",
        followers_count: "Jumlah Followers",
      },
      categoryOptions: { fnb: "Dining", accommodation: "Akomodasi / Hotel", both: "Keduanya" },
      success: "Terima kasih! Mengarahkan ke WhatsApp...",
      error: "Terjadi kesalahan. Coba lagi atau hubungi kami.",
      required: "wajib diisi",
    },
    footer: {
      tagline: "MCN premium untuk creator Dining dan akomodasi di Indonesia.",
      explore: "Eksplor",
      contact: "Kontak",
      follow: "Ikuti Kami",
      rights: "Hak Cipta Dilindungi.",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      creators: "Creators",
      testimonial: "Testimonial",
      join: "Join",
    },
    cta: {
      join: "Join Now",
      joinNetwork: "Join the Exclusive Network",
      explore: "Explore",
      submit: "Submit Application",
      submitWa: "Apply via WhatsApp",
      sending: "Sending...",
    },
    hero: {
      eyebrow: "Premium MCN · 2026",
      title1: "Turning Attention",
      title2: "Into Transaction.",
      desc: "Our creator‑commerce engine transforms influence into brand growth, from viral food moments to billion‑rupiah GMV for our partners.",
      stat1: "Adtree Creators",
      stat2: "Brand Partners",
      stat3: "GMV",
      stat4: "Monthly Reach",
    },
    about: {
      eyebrow: "Who We Are",
      title: "We connect flavor, spaces, and stories.",
      p1: "Adtree Go is a next‑generation multi‑channel network (MCN) — laser‑focused on two of Indonesia's fastest growing verticals: food & beverage and accommodation. We help creators monetize their craft while helping brands build authentic stories.",
      p2: "From influential food reviewers to staycation storytellers, we curate the best creators to collaborate with restaurants, cafés, hotels, and premium villas — all under one ecosystem.",
      pillarsTitle: "Our Pillars",
      pillar1Title: "Premium Curation",
      pillar1Desc: "Every creator passes strict curation to safeguard brand quality.",
      pillar2Title: "Commercialization",
      pillar2Desc: "Transparent rate cards, exclusive brand deals, and loyalty vouchers.",
      pillar3Title: "Authentic Stories",
      pillar3Desc: "Cinematic content that builds long‑term brands, not just posts.",
    },
    services: {
      eyebrow: "Our Services",
      title: "Two worlds, one network.",
      diningTag: "Adtree Go Dining",
      diningTitle: "For Dining Creators",
      diningDesc: "Restaurants, cafés, gourmet, street food — we connect you with premium culinary brands and nationwide campaigns.",
      diningPoints: ["Restaurant & FMCG brand deals", "Exclusive food vouchers", "Photo & video production", "Multi‑platform distribution"],
      stayTag: "Adtree Go Stay / Luxe",
      stayTitle: "For Accommodation Creators",
      stayDesc: "Hotels, resorts, villas, glamping — tell the story of luxury stays with Indonesia's best hospitality brands.",
      stayPoints: ["Exclusive staycations", "Premium hotel vouchers", "Hospitality storytelling", "Destination collaborations"],
    },
    benefits: {
      eyebrow: "Why Adtree Go",
      title: "More than just creator management.",
      list: [
        { t: "Consistent Monetization", d: "Monthly brand deals at fair and transparent rates." },
        { t: "Exclusive Vouchers", d: "Access to hotel & dining vouchers for selected creators." },
        { t: "Massive Exposure", d: "Your content distributed to a 10M+ audience network." },
        { t: "Creative Team", d: "In‑house photographers, videographers, and editors at your service." },
        { t: "Legal & Contracts", d: "We handle contracts, invoices, and tax — you focus on the craft." },
        { t: "Community", d: "Join the best Dining and hospitality creator community." },
      ],
    },
    partners: {
      eyebrow: "Trusted by Brands",
    },
    testimonials: {
      eyebrow: "Testimonials",
      title: "What our creators say.",
    },
    register: {
      eyebrow: "Creator Registration",
      title: "Time to level up. Become an Adtree Go creator.",
      desc: "Complete the form below. Our team will reach out within 3–5 business days.",
      labels: {
        full_name: "Full Name",
        email: "Email",
        whatsapp: "WhatsApp",
        category: "Category",
        social_handle: "Instagram / TikTok",
        followers_count: "Followers",
      },
      categoryOptions: { fnb: "Dining", accommodation: "Accommodation / Hotel", both: "Both" },
      success: "Thanks! Redirecting to WhatsApp...",
      error: "Something went wrong. Please try again or contact us.",
      required: "is required",
    },
    footer: {
      tagline: "Premium MCN for Dining and accommodation creators in Indonesia.",
      explore: "Explore",
      contact: "Contact",
      follow: "Follow Us",
      rights: "All Rights Reserved.",
    },
  },
};

export const partnerBrands = [
  "KFC",
  "Hokben",
  "Dominos",
  "Rejuve",
  "Momoyo",
  "Roti'O",
  "GAGA",
  "Emadoz",
  "Dough Lab",
  "SwissBel Hotel",
  "Alof Hotel",
  "101 Hotel",
  "The Orient Hotel",
  "JW Marriot Hotel",
  "and many more",
];

export const testimonials = [
  {
    name: "Wahyuni Oktavia Saragi",
    handle: "@ayusrg19",
    role: "Dining Creator",
    avatar:
      "https://customer-assets.emergentagent.com/job_adtree-go-landing/artifacts/kct1s9ip_AYUSRG.jpeg",
    quoteId:
      "Saya benar-benar terkejut waktu menerima reward dari Adtree Go. Lebih dari sekadar campaign dan kesempatan, yang paling menonjol adalah bagaimana tim ini sungguh menghargai creator. Terima kasih atas dukungan, semangat, dan apresiasinya — semua itu memotivasi saya untuk terus berkarya dan berkembang bersama komunitas.",
    quoteEn:
      "I was genuinely surprised when I received the reward from AdtreeGo. Beyond the campaigns and opportunities, what stands out the most is how the team truly appreciates creators. Thank you for all the support, encouragement, and recognition. It motivates me to keep creating and growing with the community.",
  },
  {
    name: "Belanja Recehan",
    handle: "@belanjarecehan_",
    role: "Dining Creator",
    avatar:
      "https://customer-assets.emergentagent.com/job_adtree-go-landing/artifacts/9el3n61t_belanjarecehan.jpeg",
    quoteId:
      "Sejujurnya, saya tidak bisa mengungkapkan dengan kata-kata betapa bersyukurnya saya. Dukungan dari tim Adtree Go jauh melampaui sekadar campaign creator — mereka benar-benar peduli pada creator-nya. Apresiasi, reward, dan perhatian personal yang diberikan membuat saya merasa dihargai dan terinspirasi untuk terus membuat konten.",
    quoteEn:
      "I honestly can't put into words how grateful I am. The support from the AdtreeGo team goes far beyond creator campaigns — they genuinely care about their creators. The appreciation, rewards, and personal attention made me feel valued and inspired to continue creating content.",
  },
  {
    name: "Jidda Kusnandar",
    handle: "@jiddakusnandar",
    role: "Travel Creator",
    avatar:
      "https://customer-assets.emergentagent.com/job_adtree-go-landing/artifacts/spksjl48_jiddakusnandar.jpeg",
    quoteId:
      "Salah satu alasan saya senang bekerja sama dengan Adtree Go adalah komunikasinya yang jelas dan pembayaran yang selalu tepat waktu.",
    quoteEn:
      "One of the reasons I enjoy working with AdtreeGo is the clear communication and timely payouts.",
  },
  {
    name: "Diki Khaerudin",
    handle: "@dikikhaerudin",
    role: "Travel Creator",
    avatar:
      "https://customer-assets.emergentagent.com/job_adtree-go-landing/artifacts/qfroncm4_dikikhaerudin.jpeg",
    quoteId:
      "Satu hal yang paling saya apresiasi dari Adtree Go: pembayarannya selalu jelas dan tepat waktu.",
    quoteEn:
      "One thing I appreciate about AdtreeGo: payments are always clear and on time.",
  },
];
